'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SimiLookupController = function () {
  function SimiLookupController(authService, lookupService, loadingService, enums, $q) {
    "ngInject";

    (0, _classCallCheck3.default)(this, SimiLookupController);
    if (!authService.validateUser(false, 'Vehicle', enums.PERMISSION_TYPE.View)) {
      return;
    }

    this.authService = authService;
    this.lookupService = lookupService;
    this.loadingService = loadingService;
    this.enums = enums;
    this.$q = $q;

    this.regNo = '';
    this.msg = '';
    this.data = null;

    this.initializeLookups();
    this.loadEnumLists();
  }

  (0, _createClass3.default)(SimiLookupController, [{
    key: 'initializeLookups',
    value: function initializeLookups() {
      var _this = this;

      var ctrl = this;
      var deferred = ctrl.$q.defer();

      this.lookupService.lookupBrands().then(function (brands) {
        _this.allBrands = brands;

        _this.lookupService.lookupBrandModels().then(function (brandModels) {
          _this.allBrandModels = brandModels;
        });
      });

      return deferred.promise;
    }
  }, {
    key: 'convertEnumToKeyValueList',
    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
      var objList = [];

      if (defaultOption) {
        objList.push({
          id: null,
          name: 'Please Select'
        });
      }

      for (var prop in enumObj) {
        objList.push({
          id: enumObj[prop],
          name: prop
        });
      }

      return objList;
    }
  }, {
    key: 'loadEnumLists',
    value: function loadEnumLists() {
      this.enumLists = {
        color: this.convertEnumToKeyValueList(this.enums.COLOR),
        vehicleBodyType: this.convertEnumToKeyValueList(this.enums.VEHICLE_BODY_TYPE),
        transmissionType: this.convertEnumToKeyValueList(this.enums.TRANSMISSION_TYPE),
        fuelType: this.convertEnumToKeyValueList(this.enums.FUEL_TYPE)
      };
    }
  }, {
    key: 'lookupVehicle',
    value: function lookupVehicle() {
      var _this2 = this;

      this.msg = '';

      if (!this.regNo) {
        return;
      }

      this.loadingService.showLoading('vehicleData', 'Looking up vehicle ...');

      this.lookupService.lookupVehicleByRegNo(this.authService.authData.currentLocation.key, 1, this.regNo, false).then(function (response) {
        _this2.data = response.data;

        _this2.data.make = (0, _lodash.find)(_this2.allBrands, function (o) {
          return o.brandId === _this2.data.brandId;
        }).name;
        _this2.data.model = _this2.data.brandModelId ? (0, _lodash.find)(_this2.allBrandModels, function (o) {
          return o.brandModelId === _this2.data.brandModelId;
        }).name : '';
        _this2.data.colorName = _this2.reverseLookup(_this2.enumLists.color, _this2.data.color);
        _this2.data.vehicleBodyTypeName = _this2.reverseLookup(_this2.enumLists.vehicleBodyType, _this2.data.vehicleBodyType);
        _this2.data.transmissionTypeName = _this2.reverseLookup(_this2.enumLists.transmissionType, _this2.data.transmissionType);
        _this2.data.fuelTypeName = _this2.reverseLookup(_this2.enumLists.fuelType, _this2.data.fuelType);
      }).catch(function (err) {
        _this2.msg = 'Could not fetch vehicle ' + _this2.regNo + '. Please check registration number or lookup settings and try again';
      }).finally(function () {
        _this2.loadingService.hideLoading('vehicleData');
      });
    }
  }, {
    key: 'reverseLookup',
    value: function reverseLookup(list, id) {
      var item = (0, _lodash.find)(list, function (o) {
        return o.id === id;
      });

      if (item) {
        return item.name;
      }
    }
  }]);
  return SimiLookupController;
}();

exports.default = SimiLookupController;


// WEBPACK FOOTER //
// ./client/app/components/vehicle/simiLookup/simiLookup.controller.js